import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style={{
  enableBackground: "new 0 0 512 512"
}} xmlSpace="preserve" ref={ref} {...props}><path style={{
    fill: "#F5F5F5"
  }} d="M473.885,88.279H38.115C17.045,88.403,0,105.517,0,126.617v129.385h512V126.617  C512,105.517,494.955,88.403,473.885,88.279z" /><g><path style={{
      fill: "#FF4B55"
    }} d="M0,385.376c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345   V256.003H0V385.376z" /><path style={{
      fill: "#FF4B55"
    }} d="M176.552,141.245c-63.38,0-114.759,51.38-114.759,114.759H291.31   C291.31,192.623,239.932,141.245,176.552,141.245z" /></g><path style={{
    fill: "#F5F5F5"
  }} d="M176.552,370.762c63.38,0,114.759-51.38,114.759-114.759H61.793  C61.793,319.382,113.173,370.762,176.552,370.762z" /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>;
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };